import { getToken, logout, refreshAccessToken } from '@/services/authService';

let sessionEnded = false;

/**
 * fetch autenticado contra BridgeHub. Agrega el Bearer token y, ante un 401,
 * intenta renovar con el refresh token y reintenta UNA vez. Solo cierra sesión
 * (logout + reload al login) si el refresh también falla.
 */
export async function authedFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const withToken = (): RequestInit => {
    const token = getToken();
    return {
      ...init,
      headers: { ...(init.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    };
  };

  let res = await fetch(input, withToken());
  if (res.status === 401) {
    const renewed = await refreshAccessToken();
    if (renewed) res = await fetch(input, withToken());
    if (res.status === 401) {
      logout();
      if (!sessionEnded) {
        sessionEnded = true;
        window.location.reload();
      }
      throw new Error('Sesión expirada — vuelve a entrar');
    }
  }
  return res;
}
